import { render, staticRenderFns } from "./FormConfigurator.vue?vue&type=template&id=5b68631e&scoped=true"
import script from "./FormConfigurator.vue?vue&type=script&lang=js"
export * from "./FormConfigurator.vue?vue&type=script&lang=js"
import style0 from "./FormConfigurator.vue?vue&type=style&index=0&id=5b68631e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68631e",
  null
  
)

export default component.exports